module.exports = __webpack_public_path__ + "media/images/photo/plans/places/daisen_park-c5aeb49db927f115ec30b348081f546b.png";